import React from 'react';
export function CTABanner() {
  return <section className="bg-[#E41C1C] py-16" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-40">
          Need dependable trash service?
        </h2>
        <p className="text-xl text-white mb-8" data-id="element-41">
          Call{' '}
          <a href="tel:231-796-2952" className="font-bold underline hover:text-gray-200" data-id="element-42">
            (231) 796-2952
          </a>{' '}
          or request service online today!
        </p>
        <button className="bg-white text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-43">
          Request Service
        </button>
      </div>
    </section>;
}